import React from 'react'
import './seealso.styles.scss'
import { Button } from '@mui/material'
import { ReactComponent as Right } from '../../Assets/arrow-right.svg'
import Ecommerce from '../../Assets/ecommerce.png'
import Fidelity from '../../Assets/fidelity.png'
import Inventory from '../../Assets/inventory.png'
import Selfscanning from '../../Assets/selfscanning.png'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

const SeeAlso = ({ ecommerce, self, fidelity, inventory }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className='seealso'>
            <label aria-label="Scopri anche" className='title'>Scopri anche</label>
            <div className='seealso-container'>
                {!ecommerce &&
                    <div className='card'>
                        <img src={Ecommerce} alt="ecommerce.png" />
                        <labe aria-label={t("footer.ecomemerce")} l className='title'>{t("footer.ecommerce")}</labe>
                        <label aria-label={t("seealso.ecommerce")} className='subtitle'>{t("seealso.ecommerce")}</label>
                        <div>
                            <Button aria-label={t("discovermore")} variant='text' onClick={() => navigate('/smartbip/ecommerce')}>{t("discovermore")} <Right /></Button>
                        </div>
                    </div>
                }
                {!self &&
                    <div className='card'>
                        <img src={Selfscanning} alt="selfscanning.png" />
                        <label aria-label={t("footer.selfscanning")} className='title'>{t("footer.selfscanning")}</label>
                        <label aria-label={t("seealso.selfscanning")} className='subtitle'>{t("seealso.selfscanning")}</label>
                        <div>
                            <Button aria-label={t("discovermore")} variant='text' onClick={() => navigate('/smartbip/selfscanning')}>{t("discovermore")} <Right /></Button>
                        </div>
                    </div>
                }
                {!fidelity &&
                    <div className='card'>
                        <img src={Fidelity} alt="fidelity.png" />
                        <label aria-label={t("footer.fidelity")} className='title'>{t("footer.fidelity")}</label>
                        <label aria-label={t("seealso.fidelity")} className='subtitle'>{t("seealso.fidelity")}</label>
                        <div>
                            <Button aria-label={t("discovermore")} variant='text' onClick={() => navigate('/smartbip/fidelity')}>{t("discovermore")} <Right /></Button>
                        </div>
                    </div>
                }
                {!inventory &&
                    <div className='card'>
                        <img src={Inventory} alt="inventory.png" />
                        <label aria-label={t("footer.inventory")} className='title'>{t("footer.inventory")}</label>
                        <label aria-label={t("seealso.inventory")} className='subtitle'>{t("seealso.inventory")}</label>
                        <div>
                            <Button aria-label={t("discovermore")} variant='text' onClick={() => navigate('/smartbip/inventory')}>{t("discovermore")} <Right /></Button>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default SeeAlso